export const isWithinTimeRange = (timings, targetDay = null) => {
  if (!timings || !Array.isArray(timings)) return false;

  const today = new Date();
  const now = new Date();
  const currentDay =
    targetDay || today.toLocaleDateString("en-US", { weekday: "long" });
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  return timings.some(({ day, startTime, endTime }) => {
    if (day !== currentDay) return false;

    const [startH, startM] = startTime.split(":").map(Number);
    const [endH, endM] = endTime.split(":").map(Number);
    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;

    if (startMinutes <= endMinutes) {
      return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
    } else {
      return currentMinutes >= startMinutes || currentMinutes <= endMinutes;
    }
  });
};
